import { Injectable }     from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { User }        from '../../shared/entities/user';
import { Tracker }        from '../../shared/entities/tracker';
import { Position }        from '../../shared/entities/position';
import { Message }        from '../../shared/entities/message';
import { Observable }     from '../../../node_modules/rxjs/Observable';

import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { SERVER_URL } from './server-url';

@Injectable()
export class AuthenticationService {
    private authenticationUrl = SERVER_URL + '/api/authentication';
    //private authenticationUrl = 'http://104.198.40.29:3005/api/authentication';  // URL to web API
    //private authenticationUrl = 'http://localhost:3005/api/authentication';  // URL to web API
    //private authenticationUrl = 'http://192.168.15.8:3005/api/authentication';  // URL to web API
    public userLogged:User;
    public isLogged:boolean = false;
    
    public isOpenMenuModule:boolean = false;

    public isLoading:boolean = false;
    public isShowChangePassState:string = 'void';

    constructor (private http: Http) {}

    login (user:User): Observable<User> {
       
        return this.http.post(this.authenticationUrl + '/login', user)
            .map(this.onLogon)
            .catch(this.handleError);
        
    }

    changePassword(user:User): Observable<boolean> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + user.token);

        return this.http.post(this.authenticationUrl + '/change-pass', user, {headers: headers})
                    .map(this.onChangePassword)
                    .catch(this.handleError);
    }

    setLoading(isLoading:boolean) {
        this.isLoading = isLoading;
    }

    private onLogon(res: Response | any)  {
        let body = res.json();
        //console.log('BODY -> ' + JSON.stringify(body));
        var user = new User(body.user.id, null, null, body.user.token);
        return user;
    }

    private onChangePassword(res: Response | any)  {
        let body = res.json();
            
        if (res.status == '200') {
            return true;
        }
        
        return false;
    }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } 
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/services/authentication.service.ts